var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRateHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.237,
    height: 35.22,
    viewBox: "0 0 35.237 35.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.109,
    y1: 0.085,
    x2: 0.943,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#feb31d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb730"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8c218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb21e"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Subtraction_1",
    x: 0,
    y: 0,
    width: 35.237,
    height: 35.22,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#13062f",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2106",
    x: 8.157,
    y: 8.191,
    width: 21.295,
    height: 20.824,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10088",
    "data-name": "Group 10088",
    transform: "translate(-1117.559 -5647.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8372",
    "data-name": "Group 8372",
    transform: "translate(1121.61 5652.603)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 11.619,
    cy: 11.61,
    rx: 11.619,
    ry: 11.61,
    transform: "translate(0 0.948)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8371",
    "data-name": "Group 8371",
    transform: "translate(0.949 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 11.619,
    cy: 11.61,
    rx: 11.619,
    ry: 11.61,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5, -5)",
    filter: "url(#Subtraction_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1-2",
    "data-name": "Subtraction 1",
    d: "M11.619,23.22A11.609,11.609,0,0,1,3.4,3.4a11.625,11.625,0,0,1,16.431,0,11.61,11.61,0,0,1-8.215,19.82Zm0-21.285A9.675,9.675,0,1,0,21.3,11.61,9.689,9.689,0,0,0,11.618,1.935Z",
    transform: "translate(5 5)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5, -5)",
    filter: "url(#Path_2106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2106-2",
    "data-name": "Path 2106",
    d: "M2.577,8.8c2.051.162,4.791-.45,6.061-2.237A3.472,3.472,0,0,0,9.243,3.93C8.767,1.172,4.988-.449.206.11l0,2.24C4,2.025,7.244,2.39,7.8,4.282c.848,2.866-3.4,3.668-3.882,3.65a2.309,2.309,0,0,0,.556-1.4A2.239,2.239,0,0,0,0,6.53C0,8.075,1.234,8.717,2.577,8.8Z",
    transform: "translate(12.16 12.19)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateHeader);
export default __webpack_public_path__ + "static/media/rate_header.d636e13cbf0bece4209b256e6c789075.svg";
export { ForwardRef as ReactComponent };